export default "__VITE_ASSET__CsSeFKlD__"